@if(agentInfo(); as agentInfo) {
@if(displayMode() === 'full') {
<ng-container *ngTemplateOutlet="settingsContent"></ng-container>
} @else {
<div class="tg-label tw-flex tw-items-center tw-gap-4">
  @switch (mode()) {
  @case('info') {
  <div pRipple class="tw-flex tw-gap-2 tw-p-1 tw-px-2">
    @if(isSoftphoneConnecting) {
    <i class="pi pi-spinner pi-spin text-warning tw-text-lg tw-font-bold"></i>
    } @else {
    <i class="pi pi-headphones {{available ? 'text-success' : 'text-danger'}} tw-text-lg tw-font-bold"></i>
    }
    <div class="tw-flex tw-flex-col">
      <span>{{statusText}}</span>
      <span [class.tw-line-through]="!available && !isSoftphoneConnecting">{{transferTargetLabel}}</span>
      @if(!isVirtualAgent()) {
      <small class="text-muted">Soft phone: {{softPhoneStatusText}}</small>
      }
    </div>
  </div>
  }
  @case('edit') {
  <div pRipple class="tw-flex tw-gap-2 tw-p-1 tw-px-2 hover:surface-main tw-rounded-lg tw-cursor-pointer"
    [matMenuTriggerFor]="hasValidPhone() ? availabilityMenu : null"
    (click)="!disabled() && (hasValidPhone() ? undefined : dialog.open(settingsDialog))">
    @if(isSoftphoneConnecting) {
    <i class="pi pi-spinner pi-spin text-warning tw-text-lg tw-font-bold"></i>
    } @else {
    <i class="pi pi-headphones {{available ? 'text-success' : 'text-danger'}} tw-text-lg tw-font-bold"></i>
    }
    <div class="tw-flex tw-flex-col">
      <span>{{statusText}}</span>
      <span [class.tw-line-through]="!available && !isSoftphoneConnecting">{{transferTargetLabel}}</span>
    </div>
  </div>
  }
  }
</div>

<mat-menu #availabilityMenu="matMenu" class="w-fit-content">
  <div class="uw-fields-container tw-p-4">
    <div>
      <div class="tg-title">Quick set availability</div>
      <mat-button-toggle-group [(ngModel)]="agentInfo!.liveTransfer!.override" (change)="setAvailability()"
        [disabled]="disabled()">
        <mat-button-toggle [value]="'schedule'">Follow Schedule</mat-button-toggle>
        <mat-button-toggle [value]="'available'">Always Available</mat-button-toggle>
        <mat-button-toggle [value]="'unavailable'">Always Unavailable</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="tw-flex tw-justify-between">
      <div>
        @if(agentInfo?.liveTransfer?.onTransferAction === 'paused') {
        <button mat-flat-button class="btn-warning"
          title="Paused after a transfer. Need to unpause to get the next transfer."
          (click)="agentInfo.liveTransfer!.onTransferAction='pause';setAvailability()"
          [disabled]="disabled()"><mat-icon>pause</mat-icon>
          <span>Paused — click to get next transfer</span>
        </button>
        }
      </div>
      <button mat-button class="tw-self-end" (click)="dialog.open(settingsDialog)" [disabled]="disabled()">
        <span>{{disabled() ? 'View details...' : 'More options...'}}</span>
      </button>
    </div>
  </div>
</mat-menu>
}

<ng-template #settingsDialog>
  <div class="tw-flex tw-items-center">
    <div mat-dialog-title>
      <i class="pi pi-headphones {{available ? 'text-success' : 'text-danger'}} tw-text-lg tw-font-bold"></i>
      Availability Settings
    </div>
    <button mat-icon-button mat-dialog-close class="tw-ms-auto tw-me-2">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <ng-container *ngTemplateOutlet="settingsContent"></ng-container>
  </mat-dialog-content>
  <mat-dialog-actions></mat-dialog-actions>
</ng-template>

<ng-template #settingsContent>
  <div class="uw-fields-container">
    <div>
      <div class="tg-title">Availability Override</div>
      <mat-button-toggle-group [(ngModel)]="agentInfo!.liveTransfer!.override" (change)="setAvailability()"
        [disabled]="disabled()">
        <mat-button-toggle [value]="'schedule'">Follow Schedule</mat-button-toggle>
        <mat-button-toggle [value]="'available'">Always Available</mat-button-toggle>
        <mat-button-toggle [value]="'unavailable'">Always Unavailable</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="tg-title">Transfer Target</div>
    @if(transferBinding(); as binding){
      @if(destinationKind() === 'provider'){<div class="uw-message uw-message-info">The provider supplies the SIP destination after reserving an agent. Local eligibility does not indicate provider capacity.</div>}
      @else {
        <mat-form-field><mat-label>{{destinationKind() === 'sip' ? 'SIP destination' : 'Phone destination'}}</mat-label>
          <input matInput [ngModel]="binding.destination" (ngModelChange)="transferBinding.set({integrationId: binding.integrationId, destination: $event})" [disabled]="disabled()" />
          @if(destinationKind() === 'sip'){<mat-hint>sip:user&#64;host[:port]; optional transport=udp, tcp or tls.</mat-hint>}
        </mat-form-field>
      }
    } @else {
      <mat-form-field>
        <mat-label>Transfer Phone</mat-label>
        <input matInput [(ngModel)]="agentInfo!.liveTransfer!.phone" (change)="setAvailability()" [disabled]="disabled()" />
      </mat-form-field>
    }
    @if(!isVirtualAgent()){
    <div class="tw-space-y-1">
      <div class="tg-title">After a transfer,</div>
      <mat-button-toggle-group [ngModel]="getOnTransferAction()"
        (ngModelChange)="agentInfo!.liveTransfer!.onTransferAction = $event; setAvailability()" [disabled]="disabled()">
        <mat-button-toggle [value]="'resume'">Available Automatically</mat-button-toggle>
        <mat-button-toggle [value]="'pause'">Manually Unpause</mat-button-toggle>
      </mat-button-toggle-group>
      <div class="tg-sm text-muted">
        Automatically available means the agent will be available for the next transfer immediately after
        finishing a transfer.<br />
        Manually unpause means the agent will have to manually unpause availability to receive the next transfer.
      </div>
    </div>
    @if(agentInfo?.liveTransfer?.softPhone) {
    <div class="tw-space-y-1">
      <div class="tg-title">Soft Phone</div>
      <mat-checkbox [(ngModel)]="agentInfo!.liveTransfer!.softPhone!.enabled" (change)="setAvailability()"
        [disabled]="disabled()">Enable soft phone</mat-checkbox>
      <mat-form-field class="tw-w-full">
        <mat-label>Auto answer</mat-label>
        <mat-select aria-label="Auto answer" [ngModel]="agentInfo?.liveTransfer?.softPhone?.autoAnswerMode || 'campaign'"
          (ngModelChange)="setAutoAnswerMode($event)" [disabled]="disabled()">
          <mat-option value="all">Auto answer for all calls</mat-option>
          <mat-option value="campaign">Based on campaign requirements</mat-option>
        </mat-select>
        <mat-hint>Transfer Hybrid calls always auto-answer. A beep plays before automatic answering.</mat-hint>
      </mat-form-field>
    </div>
    <div>
      <mat-button-toggle-group [(ngModel)]="agentInfo!.liveTransfer!.targetPriority" (change)="setAvailability()"
        [disabled]="disabled() || !(agentInfo!.liveTransfer?.softPhone?.enabled)">
        <mat-button-toggle [value]="'soft-phone'">Soft phone</mat-button-toggle>
        <mat-button-toggle [value]="'phone-number'">Agent phone number</mat-button-toggle>
        <mat-button-toggle [value]="'fallback'">Fallback</mat-button-toggle>
      </mat-button-toggle-group>
      <div class="tg-sm text-muted">Fallback uses the soft phone when connected; otherwise it uses the agent phone.
        A busy soft phone does not fall back to the agent phone.</div>
    </div>
    }
    }
    <mat-divider></mat-divider>
    <app-timezone [(timezone)]="agentInfo!.timezone" [required]="true" (timezoneChange)="setAvailability()"
      [disabled]="disabled()"></app-timezone>
    <div class="tw-space-y-1">
      <div class="tg-label">Choose states you want to accept transfers from</div>
      <small class="tg-sm text-muted">Clear selection to accept all calls</small>
      <app-state-selector [(states)]="agentInfo!.regions!" (statesChange)="setAvailability()"
        [disabled]="disabled()"></app-state-selector>
    </div>

    <div class="tg-section-title">Weekly Schedule</div>
    <table mat-table [dataSource]="agentInfo!.liveTransfer!.schedule!">
      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef>Enabled</th>
        <td mat-cell *matCellDef="let item">
          <mat-checkbox [(ngModel)]="item.enabled" (change)="setAvailability()" [disabled]="disabled()"></mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="weekday">
        <th mat-header-cell *matHeaderCellDef>Weekday</th>
        <td mat-cell *matCellDef="let item">{{item.day|titlecase}}</td>
      </ng-container>
      <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef>From</th>
        <td mat-cell *matCellDef="let item">
          <mat-form-field>
            <input matInput type="time" [(ngModel)]="item.from" (change)="setAvailability()" [disabled]="disabled()" />
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="to">
        <th mat-header-cell *matHeaderCellDef>To</th>
        <td mat-cell *matCellDef="let item">
          <mat-form-field>
            <input matInput type="time" [(ngModel)]="item.to" (change)="setAvailability()" [disabled]="disabled()" />
          </mat-form-field>
        </td>
      </ng-container>

      @let cols = ['enabled', 'weekday', 'from', 'to'];
      <tr mat-header-row *matHeaderRowDef="cols"></tr>
      <tr mat-row *matRowDef="let row; columns: cols"></tr>
    </table>

    <mat-form-field appearance="fill">
      <mat-label>Max Sequential Missed Transfers</mat-label>
      <input matInput type="number" id="maxSeqMissedTransfers" name="maxSeqMissedTransfers"
        [(ngModel)]="agentInfo.liveTransfer!.maxSeqMissedTransfers" min="0" (change)="setAvailability()"
        [disabled]="disabled()" />
      @if(isVirtualAgent()) {
      <mat-hint>Virtual agents do not use the system default. Empty or zero means unlimited.</mat-hint>
      } @else {
      <mat-hint>System default if empty; unlimited if zero.</mat-hint>
      }
    </mat-form-field>

  </div>
</ng-template>
}
